// extracted by mini-css-extract-plugin
module.exports = {"pagination_wrapper":"pagination_pagination_wrapper__Z8is9","shwing_num":"pagination_shwing_num__DCGkn"};